import axios from '@/utils/api'
import { KEYS, setItem, getItem } from '@/store/local/localStorage'
import * as jwtDecode from 'jwt-decode'
import { SET_USUARIO, CLEAR_USUARIO, SET_USUARIO_PERMISSOES } from '../mutation-types'

const state = {
  usuarioLogado: null
}

const getters = {
  usuarioLogado: (state) => state.usuarioLogado
}

const mutations = {
  [SET_USUARIO] (state, payload) {
    state.usuarioLogado = payload
  },

  [SET_USUARIO_PERMISSOES] (state, payload) {
    state.usuarioLogado = { ...state.usuarioLogado, permissoes: payload }
  },

  [CLEAR_USUARIO] (state) {
    state.usuarioLogado = null
  }
}

const actions = {
  getToken ({ actions }) {
    return getItem(KEYS.LOGIN.token)
  },

  setToken ({ actions }, token) {
    setItem(KEYS.LOGIN.jwt, `Bearer ${token}`)
    setItem(KEYS.LOGIN.token, `${token}`)
  },

  getUsuario ({ actions }) {
    return !!localStorage.getItem(KEYS.LOGIN.usuario) || !!localStorage.getItem(KEYS.LOGIN.jwt) ? jwtDecode(localStorage.getItem(KEYS.LOGIN.jwt)) : null
  },

  async isAutenticado ({ state, commit, getters }) {
    return !!localStorage.getItem(KEYS.LOGIN.usuario) || !!localStorage.getItem(KEYS.LOGIN.jwt)
  },

  async loginPortalSeguranca ({ commit, dispatch }, { login, senha }) {
    const data = await axios({
      method: 'POST',
      url: `autenticacao/login`,
      data: {
        login,
        senha
      }
    })

    setItem(KEYS.LOGIN.jwt, `${data.tokenType} ${data.accessToken}`)
    setItem(KEYS.LOGIN.token, `${data.accessToken}`)

    const usuario = await dispatch('getUsuario')
    commit('SET_USUARIO', usuario)
  },

  async selecionePerfil ({ commit, dispatch }, { moduloId, perfilId }) {
    const data = await axios({
      method: 'get',
      url: `autenticacao/modulo/${moduloId}/perfil/${perfilId}`
    })

    setItem(KEYS.LOGIN.jwt, `${data.tokenType} ${data.accessToken}`)
    setItem(KEYS.LOGIN.token, `${data.accessToken}`)

    const usuario = await dispatch('getUsuario')
    commit('SET_USUARIO', usuario)
  },

  async selecioneModulo ({ commit, dispatch }, { moduloId }) {
    const data = await axios({
      method: 'get',
      url: `autenticacao/modulo?moduloId=${moduloId}`
    })
    setItem(KEYS.LOGIN.jwt, `${data.tokenType} ${data.accessToken}`)
    setItem(KEYS.LOGIN.token, `${data.accessToken}`)

    const usuario = await dispatch('getUsuario')
    commit('SET_USUARIO', usuario)
  },

  async setPermissoes ({ commit, dispatch }) {
    if (state.usuarioLogado && [undefined, null].includes(state.usuarioLogado.permissoes)) {
      const data = await axios({
        method: 'get',
        url: 'autenticacao/permissoes',
        loader: false
      })
      commit('SET_USUARIO_PERMISSOES', data)
    }
  },

  async logout ({ dispatch, commit }) {
    await axios({
      method: 'get',
      url: 'autenticacao/logout',
      public: true
    })

    commit('CLEAR_USUARIO')
  }
}

export default {
  namespaced: true,
  actions,
  mutations,
  state,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js